import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

class Paragraph extends Component {

    constructor(props){
        super(props)
        this.state = {
            expanded: this.props.expand
        }
    }

    componentDidMount(){
        this.setState({
            expanded: this.props.content.IsCollapsed == "1" ? false : true
        })
    }
    componentDidUpdate(prevProps){
        if(this.props.expand !== prevProps.expand){
            this.setState({
                expanded: this.props.expand
            })
        }
    }
    handleChange = () => {
        this.setState({
            expanded: !this.state.expanded
        })
    }
    render() {
        let paragraph = []
        if(this.props.content.CanCollapse == "1"){
            paragraph = <Accordion expanded={this.state.expanded} onChange={this.handleChange}>
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Typography>{this.props.content.Header}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box style={{overflowWrap:'break-word', wordBreak:'break-word'}}>
                                    <Typography dangerouslySetInnerHTML={{__html: this.props.content.Content}}></Typography>
                                </Box>

                            </AccordionDetails>
                
                        </Accordion>
        } else {
            paragraph = <Typography gutterBottom='true' dangerouslySetInnerHTML={{__html: this.props.content.Content}}></Typography> 
        }
        return(
            <Grid style={{textAlign:'left', paddingBottom:'20px'}}>
                {paragraph}
            </Grid>
        )
    }
}

/* 
{
              "ComponentClass": "TEXTAREA",
              "ComponentFamily": "VARIANT",
              "ComponentType": "PARAGRAPH",
              "ComponentContent": {
                "Content": "<p>This report is based on an assessment you took. The assessment was intended to help you determine if you may be at risk for developing breast cancer to inform breast cancer screening, chemoprevention, and genetic testing. It was created using an evidence-based approach. The assessment uses the Breast Cancer Risk Assessment (Gail model) tool to estimate your 5-year and lifetime risk for breast cancer. Your 5-year or lifetime breast cancer risk, health, and other risk factors are used to determine your risk.</p><p>References:</p><ol><li>Banegas MP, John EM, Slattery ML, et al. Projecting Individualized Absolute Invasive Breast Cancer Risk in US Hispanic Women. J Natl Cancer Inst. 2017;109(2). <a href=\"https://www.ncbi.nlm.nih.gov/pubmed/28003316\" target=\"_blank\">https://www.ncbi.nlm.nih.gov/pubmed/28003316</a></li><li>Gail MH, Costantino JP, Pee D, et al. Projecting individualized absolute invasive breast cancer risk in African American women. J Natl Cancer Inst. 2007;99(23):1782-1792. <a href=\"https://www.ncbi.nlm.nih.gov/pubmed/18042936\" target=\"_blank\">https://www.ncbi.nlm.nih.gov/pubmed/18042936</a></li><li>Matsuno RK, Costantino JP, Ziegler RG, et al. Projecting individualized absolute invasive breast cancer risk in Asian and Pacific Islander American women. J Natl Cancer Inst. 2011;103(12):951-961. <a href=\"https://www.ncbi.nlm.nih.gov/pubmed/21562243\" target=\"_blank\">https://www.ncbi.nlm.nih.gov/pubmed/21562243</a></li><li>Gail MH, Brinton LA, Byar DP, et al. Projecting individualized probabilities of developing breast cancer for white females who are being examined annually. J Natl Cancer Inst. 1989;81(24):1879-1886. <a href=\"https://www.ncbi.nlm.nih.gov/pubmed/2593165\" target=\"_blank\">https://www.ncbi.nlm.nih.gov/pubmed/2593165</a></li></ol>",
                "Visibility": "1",
                "Header": "About this Assessment",
                "Subheader": "",
                "IsCollapsed": "1",
                "CanCollapse": "1"
              },
              "ComponentVisible": "1"
            }
*/

export default Paragraph